<template><PointPicker ref="picker" label="انبار" :address="address" :latitude="latitude" :longitude="longitude" :disabled="disabled" @select="$emit('select', $event)" @address="$emit('address', $event)" @resolving="$emit('resolving', $event)" /></template>
<script>
import PointPicker from '@/components/Map/PointPicker.vue';
export default {
  name: 'WarehouseLocationMap', components: { PointPicker },
  props: { address: { type: String, default: '' }, latitude: { type: [String, Number], default: '' }, longitude: { type: [String, Number], default: '' }, disabled: Boolean },
  methods: { refresh() { if (this.$refs.picker) this.$refs.picker.refresh(); } },
};
</script>
